import { motion } from "framer-motion";
import { Search, Scissors, Star } from "lucide-react";

const steps = [
  {
    Icon: Search,
    step: "01",
    title: "Browse",
    accent: "#FF641E",
    description:
      "Scroll your Dallas food groups on Facebook or Reddit like normal. No change to how you already discover restaurants.",
  },
  {
    Icon: Scissors,
    step: "02",
    title: "Znipd it",
    accent: "#A25AFF",
    description:
      "Draw a selection around any restaurant post with one click. That's all it takes to capture the conversation.",
  },
  {
    Icon: Star,
    step: "03",
    title: "Build your directory",
    accent: "#FF641E",
    description:
      "AI extracts the restaurant, sentiment, and ratings automatically. Your personal Dallas restaurant intel — built by the community.",
  },
];

const HowItWorks = () => {
  return (
    <section className="py-24 md:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-manrope text-xs sm:text-sm tracking-[0.25em] uppercase text-[#A25AFF] font-bold mb-4"
          >
            How It Works
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-oswald text-4xl sm:text-5xl font-bold tracking-tight text-[#F0F0EE]"
          >
            Three steps. Zero friction.
          </motion.h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {steps.map(({ Icon, step, title, accent, description }, i) => (
            <motion.div
              key={i}
              data-testid={`how-it-works-card-${i + 1}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="bg-white/[0.02] border border-white/10 backdrop-blur-sm p-8 flex flex-col items-start gap-5 hover:-translate-y-1 hover:border-[#FF641E]/40 transition-all duration-300 group rounded-sm"
            >
              {/* Icon + Step Number row */}
              <div className="flex items-center justify-between w-full">
                <div
                  className="w-12 h-12 rounded-md flex items-center justify-center"
                  style={{ background: `${accent}18` }}
                >
                  <Icon size={22} style={{ color: accent }} />
                </div>
                <span className="font-oswald text-5xl font-bold text-white/[0.07] group-hover:text-white/[0.12] transition-colors duration-300">
                  {step}
                </span>
              </div>

              <h3 className="font-oswald text-2xl sm:text-3xl font-bold text-[#F0F0EE]">
                {title}
              </h3>
              <p className="font-manrope text-[#8A8A93] leading-relaxed text-base">
                {description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
